export default __webpack_public_path__ + "static/media/Greed of Shevatas.3fd5724c.jpg";